import React, { useState } from "react";

import SideMenuItem from "./SideMenuItem";
import image from "~/images/influx_logo_white.png";
import { SignOut } from "phosphor-react";

export default function SideMenu({
  items = [],
  routesPrefix = "",
  user,
  logout,
}) {
  const [indicatorTop, setIndicatorTop] = useState(undefined);

  const onSelectItem = (element) => {
    setIndicatorTop(element.offsetTop);
  };

  const indicatorStyle =
    indicatorTop !== undefined
      ? {
          top: indicatorTop,
        }
      : null;

  return (
    <div
      id="side-menu"
      className="h-screen w-[230px] z-10 flex flex-col bg-slate-900 py-10"
    >
      <div className="h-full w-full flex flex-col">
        <img src={image} alt="" className="w-auto mx-10 pt-5" />
        <ul className="list-none w-full mt-10">
          <div
            className={`absolute h-[40px] bg-secondary text-white w-[45px] rounded-tr-xl rounded-br-xl ease-in-out ${
              indicatorStyle ? "transition-all" : "hidden"
            }`}
            style={indicatorStyle}
          />
          {items.map((i) => (
            <SideMenuItem
              {...i}
              key={i.menuKey}
              menuKey={i.menuKey}
              routePrefix={routesPrefix}
              onSelect={onSelectItem}
            />
          ))}
        </ul>
      </div>
      <div className={"flex flex-col ml-4 text-white"}>
        <div
          className="flex items-center space-x-2 h-min mt-auto hover:cursor-pointer hover:opacity-80"
          onClick={logout}
        >
          <div className="bg-white w-8 h-8 flex justify-center items-center rounded-full">
            <SignOut color="black" weight="bold" />
          </div>
          <div className="font-bold text-s">Se déconnecter</div>
        </div>
        <div className="text-s font-[RobotoMedium] text-white mt-2">
          {user.email}
        </div>
      </div>
    </div>
  );
}
